import React from 'react'
import injectSheet from 'react-jss'
import style from './style'

class CalculatorNameInput extends React.Component {
  state = { value: this.props.value, previousValue: this.props.value }

  setValue = value => {
    const { props: { callback, fnKey, currentCamera: { id } } } = this
    this.setState({ value })
    value.trim() !== '' && callback(value, fnKey, id)
  }

  componentWillReceiveProps = nextProps => {
    const { value } = nextProps
    this.setState({ value: value, previousValue: value })
  }

  onFocus = _ => {
    this.setState({ previousValue: this.state.value })
  }

  onBlur = _ => {
    const { state: { value, previousValue } } = this
    value.trim() === '' && this.setValue(previousValue)
  }

  onChange = ({ target: { value } }) => this.setValue(value)

  render() {
    const { onChange, onFocus, onBlur, state: { value }, props: { label, titleTag, unit, labelClass, width, classes } } = this
    return (
      <div className={classes.container}>
        <div title={titleTag || label} className={classes[labelClass] || classes.normalLabel}>{label}</div>
        <div className={classes.inputWrapper} >
          <span className={classes.suffix}>{unit}</span>
          <input type='text' {...{ onChange, onFocus, onBlur, value }} style={{ width }} />
        </div>
      </div>
    )
  }
}

export default injectSheet(style)(CalculatorNameInput)



// WEBPACK FOOTER //
// ./src/components/CalculatorInput/nameInput.js